module.exports = __webpack_public_path__ + "static/media/img8.2a5e2cb9.jpg";